const truthy = value =>
  value === true || value === 'true' || value === 1 || value === '1';

export const activeTrainingConversationId = (currentUser = {}) => {
  const attributes = currentUser.custom_attributes || {};
  if (
    !truthy(attributes.daily_training_active) ||
    !truthy(attributes.custom_training_active)
  ) {
    return null;
  }

  const conversationId = Number(attributes.daily_training_conversation_id || 0);
  return Number.isFinite(conversationId) && conversationId > 0
    ? conversationId
    : null;
};

export const isTrainingConversation = (conversation = {}, currentUser = {}) => {
  const additionalAttributes = conversation.additional_attributes || {};
  const customAttributes = conversation.custom_attributes || {};
  const sender = conversation.meta?.sender || {};
  const senderAdditionalAttributes = sender.additional_attributes || {};
  const senderCustomAttributes = sender.custom_attributes || {};
  const conversationId = Number(conversation.id || 0);

  const userLockedToConversation =
    activeTrainingConversationId(currentUser) === conversationId;

  return (
    userLockedToConversation ||
    truthy(additionalAttributes.daily_training) ||
    truthy(customAttributes.daily_training) ||
    truthy(senderAdditionalAttributes.daily_training) ||
    truthy(senderCustomAttributes.daily_training) ||
    Boolean(additionalAttributes.daily_training_session_id) ||
    Boolean(customAttributes.daily_training_session_id) ||
    Boolean(senderAdditionalAttributes.daily_training_session_id) ||
    Boolean(senderCustomAttributes.daily_training_session_id) ||
    Boolean(additionalAttributes.custom_training_id) ||
    Boolean(customAttributes.custom_training_id) ||
    Boolean(senderAdditionalAttributes.custom_training_id) ||
    Boolean(senderCustomAttributes.custom_training_id)
  );
};
